//mui
import { styled } from "@mui/material/styles";
import Popper from "@mui/material/Popper";

const StyledPopper = styled(Popper)(({ theme }) => ({
  "& .MuiPaper-root": {
    // border: `1px solid ${theme.palette.secondary.main}`,
  },
  "& .MuiAutocomplete-listbox": {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "4px",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#9A9A9A",
      borderRadius: "30px",
    },
    "& li": {
      fontSize: "14px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "11px",
      },
    },
  },
}));

const CustomPopper = (props) => {
  return <StyledPopper {...props} placement={props.placement || "bottom"} />;
};

export default CustomPopper;